import { Link } from "react-router-dom";
import { LogIn, LogOut, LayoutDashboard } from "lucide-react";
import { Button } from "../ui/button";

export function MobileMenu({ links, user, onNav, onLogout, onClose }) {
  return (
    <div data-testid="mobile-menu" className="md:hidden glass-strong mt-2 mx-4 rounded-lg p-4">
      {links.map((link) => (
        <button key={link.label} data-testid={`mobile-nav-${link.label.toLowerCase().replace(/\s/g, "-")}`} onClick={() => onNav(link)}
          className="block w-full text-left py-3 px-4 font-outfit text-sm text-ib-text-secondary hover:text-ib-blue transition-colors">
          {link.label}
        </button>
      ))}
      {user ? (
        <>
          {user.role === "admin" && (
            <Link to="/admin" className="block" onClick={onClose} data-testid="mobile-nav-admin">
              <Button variant="outline" className="w-full mt-2 border-ib-lime/40 text-ib-lime font-outfit">
                <LayoutDashboard className="w-4 h-4 mr-2" /> Admin
              </Button>
            </Link>
          )}
          <Button onClick={onLogout} data-testid="mobile-logout-btn" variant="outline" className="w-full mt-2 border-ib-steel/30 text-ib-text-secondary font-outfit">
            <LogOut className="w-4 h-4 mr-2" /> Logout
          </Button>
        </>
      ) : (
        <Link to="/login" className="block" onClick={onClose}>
          <Button className="w-full mt-2 bg-ib-blue hover:bg-ib-blue/90 text-white font-outfit">
            <LogIn className="w-4 h-4 mr-2" /> Login
          </Button>
        </Link>
      )}
    </div>
  );
}
